import { FC, forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { Applications } from '@clds/icon';
import { MENU_ITEM_ICON_SIZE } from '../../../ApplicationWrapper.const';
import { messages } from '../../../i18n';
import { ApplicationsDropdownItems } from '../ApplicationsDropdownWrapper/ApplicationsDropdownItems';
import { PrimaryMenuItemCommonTypes } from '../../../components/PrimaryMenu/PrimaryMenu.types';
import { PrimaryMenuItemMobile } from '../../../components/PrimaryMenu/PrimaryMenuItem';
import { DropdownMobileMenu } from '../../../components/DropdownMobileMenu/DropdownMobileMenu';

export const ApplicationsButtonTriggerMobile = forwardRef<HTMLButtonElement, PrimaryMenuItemCommonTypes>((props, ref) => (
  <PrimaryMenuItemMobile ref={ref} data-testid="mobile-trigger" analyticsMessage="products menu mobile" {...props}>
    <Applications size={MENU_ITEM_ICON_SIZE} />
  </PrimaryMenuItemMobile>
));

export interface ApplicationsDropdownButtonMobileProps {
  showVideoAppSelector?: boolean;
}

export const ApplicationsDropdownButtonMobile: FC<ApplicationsDropdownButtonMobileProps> = ({ showVideoAppSelector }) => {
  const { formatMessage } = useIntl();

  return (
    <DropdownMobileMenu headerTitle={formatMessage(messages.applicationsMenuTooltip)} trigger={<ApplicationsButtonTriggerMobile />}>
      <ApplicationsDropdownItems showVideoAppSelector={showVideoAppSelector} />
    </DropdownMobileMenu>
  );
};
